const durationPerStage = {
    "backend-server": {
        "workflow-1": [
            {
                stageName: "sync",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "dont-interrupt-me",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "preflight",
                avgDuration: "14",
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "no-jh-check",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "qa:selectors",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "prepare",
                avgDuration: 11019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "cache gems",
                        avgDuration: 113,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:production",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-production-assets",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "build-images",
                avgDuration: 19019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "build-assets-image",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-assets-image as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-gdk-image",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-qa-image",
                        avgDuration: "2",
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "fixtures",
                avgDuration: 13019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "graphql-schema-dump",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-all frontend_fixture",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "upload-frontend-fixtures",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "lint",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "audit-event-types-verify",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "code_quality",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "docs code_quality",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "eslint",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "feature-flags-usage",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gemnasium-dependency_scanning",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gemnasium-python-dependency_scanning",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "generate-apollo-graphql-schema",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "haml-lint",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "haml-lint ee",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rubocop",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "secret_detection",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "semgrep-sast",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "static-analysis",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "static-verification-with-database",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "test",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "bundle-size-review",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-storybook",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "db:check-schema",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gitlab_git_test",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "glfm-verify",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "graphql-verify",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "jest",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "jest-integration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "memory-on-boot",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec background_migration",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec integration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec system",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec unit",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee background_migration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee integration",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee system",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee unit",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "run-dev-fixtures",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "run-dev-fixtures-ee",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "verify-tests-yml",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "webpack-dev-server",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "post-test",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "coverage-frontend",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector ee",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector remainder",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector system",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector unit",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:feature-flags",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:flaky-tests-report",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:merge-auto-explain-logs",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "benchmark",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "benchmark-markdown",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
        ],
        "workflow-2": [
            {
                stageName: "sync",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "dont-interrupt-me",
                        avgDuration: 13019,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "preflight",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "no-jh-check",
                        avgDuration: 10019,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "qa:selectors",
                        avgDuration: 1001,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "prepare",
                avgDuration: 14019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "cache gems",
                        avgDuration: 113,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:production",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-production-assets",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
        ],
    },
    "frontend-b2c": {
        "workflow-1": [
            {
                stageName: "sync",
                avgDuration: 15019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "dont-interrupt-me",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "preflight",
                avgDuration: 12019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "no-jh-check",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "qa:selectors",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "prepare",
                avgDuration: 13019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "cache gems",
                        avgDuration: 113,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:production",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-production-assets",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "build-images",
                avgDuration: 14019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "build-assets-image",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-assets-image as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-gdk-image",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "build-qa-image",
                        avgDuration: "2",
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "fixtures",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "graphql-schema-dump",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-all frontend_fixture",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "upload-frontend-fixtures",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "lint",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "audit-event-types-verify",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "code_quality",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "docs code_quality",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "eslint",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "feature-flags-usage",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gemnasium-dependency_scanning",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gemnasium-python-dependency_scanning",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "generate-apollo-graphql-schema",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "haml-lint",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "haml-lint ee",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rubocop",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "secret_detection",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "semgrep-sast",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "static-analysis",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "static-verification-with-database",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "test",
                avgDuration: 15519,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "bundle-size-review",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-storybook",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "db:check-schema",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "gitlab_git_test",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "glfm-verify",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "graphql-verify",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "jest",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "jest-integration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "memory-on-boot",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec background_migration",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec integration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec system",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec unit",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee background_migration",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee integration",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee system",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec-ee unit",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "run-dev-fixtures",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "run-dev-fixtures-ee",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "verify-tests-yml",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "webpack-dev-server",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "post-test",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "coverage-frontend",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector ee",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector remainder",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector system",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:artifact-collector unit",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:feature-flags",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:flaky-tests-report",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rspec:merge-auto-explain-logs",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "benchmark",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "benchmark-markdown",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
        ],
        "workflow-2": [
            {
                stageName: "sync",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "dont-interrupt-me",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "preflight",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "no-jh-check",
                        avgDuration: 100,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "qa:selectors",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "rails-production-server-boot...",
                        avgDuration: 112,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
            {
                stageName: "prepare",
                avgDuration: 10019,
                sumDuration: 17019,
                runs: 1108,
                jobs: [
                    {
                        name: "cache gems",
                        avgDuration: 113,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:production",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "cache-assets:test as-if-foss",
                        avgDuration: 150,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                    {
                        name: "compile-production-assets",
                        avgDuration: 123,
                        baselineAvgDuration: 131.14,
                        sumDuration: 143,
                        baselineSumDuration: 131.14,
                        runs: 1,
                        baselineRuns: 36,
                    },
                ],
            },
        ],
    },
};

const pipelineFailures = [
    {
        name: "Pipeline-1",
        repo_full_name: "adadot-b2c",
        count: 12,
    },
    {
        name: "Pipeline-2",
        repo_full_name: "adadot-b2c",
        count: 5,
    },
    {
        name: "Pipeline-3",
        repo_full_name: "adadot-b2c",
        count: 9,
    },
];

const slowestPipelines = [
    {
        datetime: "2023-11-29T22:00:00.000Z",
        uv: 4000,
        amt: 2400,
    },
    {
        datetime: "2023-11-30T22:00:00.000Z",
        uv: 3000,
        pv: 1398,
    },
    {
        datetime: "2023-12-01T22:00:00.000Z",
        amt: 2290,
    },
    {
        datetime: "2023-12-02T22:00:00.000Z",
        uv: 2780,
        pv: 3908,
        "another-pipeline": 2000,
    },
    {
        datetime: "2023-12-03T22:00:00.000Z",
        "another-pipeline": 2000,
    },
    {
        datetime: "2023-12-04T22:00:00.000Z",
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        datetime: "2023-12-05T22:00:00.000Z",
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const highestRunningJobs = [
    {
        repo: "project / Backend Server",
        pipelineName: "project / Backend Server",
        name: "test:test",
        executionTime: 2598,
    },
    {
        repo: "project / Backend Server",
        pipelineName: "project / Backend Server",
        name: "install:install_dependencies",
        executionTime: 274,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:github-integration",
        executionTime: 174,
    },
    {
        repo: "project / Backend Server",
        pipelineName: "project / Backend Server",
        name: "test:lint",
        executionTime: 172,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:prod:github-integration",
        executionTime: 166,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:gitlab-integration",
        executionTime: 162,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:dynamo-store",
        executionTime: 152,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:benchmark",
        executionTime: 151,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:invite-users",
        executionTime: 148,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:google-integration",
        executionTime: 148,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:cron-analytics-framework",
        executionTime: 147,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:update-work-preferences",
        executionTime: 147,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:slack-integration",
        executionTime: 146,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:trends",
        executionTime: 146,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:email-contacts",
        executionTime: 143,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:webhooks",
        executionTime: 143,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:jira-integration",
        executionTime: 143,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:analytics-id",
        executionTime: 142,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:missions",
        executionTime: 142,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:users-timezone-setter",
        executionTime: 141,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:update-skills",
        executionTime: 141,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:achievements",
        executionTime: 141,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:multi-user-reporter",
        executionTime: 141,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "install:install_dependencies",
        executionTime: 139,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:create-new-organisation",
        executionTime: 138,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:microsoft-integration",
        executionTime: 138,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:indexer",
        executionTime: 137,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:insights",
        executionTime: 137,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:auth0-machine-tokens",
        executionTime: 137,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:capture-collaboration-time",
        executionTime: 136,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:scrapped-users-consumer",
        executionTime: 135,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:summary",
        executionTime: 129,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:update-client-verticals",
        executionTime: 128,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:integration-status",
        executionTime: 126,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "deploy:sit:execute-rds-statement",
        executionTime: 123,
    },
    {
        repo: "project / Backend Server",
        pipelineName: "project / Backend Server",
        name: "build:build",
        executionTime: 102,
    },
    {
        repo: "project / utils",
        pipelineName: "project / utils",
        name: "test:lint",
        executionTime: 69,
    },
    {
        repo: "project / Backend Server",
        pipelineName: "project / Backend Server",
        name: "pages:pages",
        executionTime: 48,
    },
];

const pipelineStats = {
    pipelines: 12,
    successRate: 0.9,
    duration: 1223,
    overall: 1233,
    baseline: {
        pipelines: 11,
        successRate: 1,
        duration: 1223,
    },
};

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const getPipelines = () => {
    return {
        pipelineStats,
        durationPerStage,
        highestRunningJobs,
        slowestPipelines,
        pipelineFailures,
        meta,
    };
};

export default getPipelines;
